import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#0597A3"
      d="M99.757 39.84a2.5 2.5 0 1 0 0-4.999 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M13.624 53.942a1.5 1.5 0 0 1 0 2.122L3.63 66.058a1.5 1.5 0 1 1-2.122-2.122l9.994-9.994a1.5 1.5 0 0 1 2.121 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M1.508 53.942a1.5 1.5 0 0 1 2.122 0l9.994 9.994a1.5 1.5 0 1 1-2.122 2.122l-9.994-9.994a1.5 1.5 0 0 1 0-2.122"
      clipRule="evenodd"
    />
    <path fill="#00D8D8" d="M87.5 104a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M101.567 6a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 0 1-3 0V7.5a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M93 14.566a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H94.5a1.5 1.5 0 0 1-1.5-1.5M21.414 88.87a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      d="M87 10.919C87 7.649 84.366 5 81.117 5H36.883C33.633 5 31 7.65 31 10.919V37h55.999V10.919z"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M45.25 87c1.243 0 2.25 1.052 2.25 2.35v7.3c0 1.298-1.007 2.35-2.25 2.35S43 97.948 43 96.65v-7.3c0-1.298 1.007-2.35 2.25-2.35M72.75 87c1.243 0 2.25 1.052 2.25 2.35v7.3c0 1.298-1.007 2.35-2.25 2.35s-2.25-1.052-2.25-2.35v-7.3c0-1.298 1.007-2.35 2.25-2.35"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      fillRule="evenodd"
      d="M41.834 18.629a2.25 2.25 0 0 1 2.25 2.25v5.412a2.25 2.25 0 0 1-4.5 0v-5.412a2.25 2.25 0 0 1 2.25-2.25"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M31 37v46.123A5.88 5.88 0 0 0 36.883 89h44.234A5.88 5.88 0 0 0 87 83.123V37z"
    />
    <path
      fill="#D8FFFF"
      fillRule="evenodd"
      d="M41.834 49.07a2.25 2.25 0 0 1 2.25 2.25v5.413a2.25 2.25 0 0 1-4.5 0V51.32a2.25 2.25 0 0 1 2.25-2.25"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconAppliancesInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconAppliancesInverted);
export default Memo;
